<template>
  <div class="max-w-2xl mx-auto px-4 dark:bg-gray-900 dark:text-gray-300">
    <BizLabel>{{ $t("address") }}</BizLabel>
    <div class="text-sm">
      <p>{{ name }}</p>
      <p>{{ address }}</p>
    </div>
  </div>
</template>

<script>
import { mapState } from "pinia";
import { useBizStore } from "@/store/index.js";
export default {
  computed: {
    ...mapState(useBizStore, ["name", "address"]),
  },
};
</script>
